const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-119"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 55.42,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 397.86,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.46,
    y: 391.8,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.56,
    y: 391.8,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.21,
    y: 395.31,
    width: 46.84,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.78,
    y: 74.39,
    width: 193.06,
    height: 138.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.85 212.99 237.75 74.39 200.9 74.39 250 212.99 286.85 212.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.76 212.99 138.66 74.39 125.22 74.39 174.32 212.99 187.76 212.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,69.63H307.05a.85.85,0,0,1,.85.86h0a.85.85,0,0,1-.85.85H95.58a.86.86,0,0,1-.86-.85h0A.86.86,0,0,1,95.58,69.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.17,
    y: 74.1,
    width: 2.29,
    height: 139.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.02,
    y: 74.1,
    width: 1.14,
    height: 139.19,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.17,
    y: 45.83,
    width: 2.29,
    height: 195.73,
    transform: "translate(57.62 345) rotate(-90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,212h0v-139H299.17V212h0v2.29H103.45Zm193.44,0V75.35H105.74V212Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 73.06,
    width: 1.14,
    height: 141.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.83 67.53 131.83 230.29 90.51 230.29 98.09 67.53 131.83 67.53",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.65 67.53 269.65 230.29 310.97 230.29 303.39 67.53 269.65 67.53",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.92,
    y: 249.79,
    width: 15.76,
    height: 127.83,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 377.62,
    width: 173.63,
    height: 4.78,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 249.79,
    width: 163.92,
    height: 127.83,
    transform: "translate(319.29 627.41) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.94,
    y: 245.62,
    width: 16.11,
    height: 4.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.05,
    y: 245.62,
    width: 167.54,
    height: 4.17,
    transform: "translate(319.63 495.41) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,321.73H83.35V258.54H235.94ZM84.41,320.67H234.88V259.6H84.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,368.86H83.35V328.05H235.94ZM84.41,367.8H234.88V329.11H84.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.91,
    y: 259.07,
    width: 111.47,
    height: 3.39,
    rx: 1.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.91,
    y: 328.58,
    width: 111.47,
    height: 3.39,
    rx: 1.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.86,
    y: 96.55,
    width: 91.68,
    height: 279.72,
    transform: "translate(787.4 472.81) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.95,
    y: 96.55,
    width: 2.91,
    height: 279.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.73,
    y: 107.22,
    width: 61.93,
    height: 258.38,
    transform: "translate(787.4 472.81) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-119"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-119",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-119"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "143.36 407.53 151.19 404.56 146.39 385.64 138.56 388.61 143.36 407.53",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.53 407.69 92.9 407.69 94.16 388.29 85.78 388.29 84.53 407.69",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74,406.72H83.53a.69.69,0,0,0-.69.57l-1.28,7.44a1.31,1.31,0,0,0,1.3,1.49c3.28-.06,5.67-.25,9.81-.25,2.54,0,10.23.27,13.75.27s3.8-3.48,2.34-3.8c-6.52-1.41-11.48-3.35-13.64-5.21A2.14,2.14,0,0,0,93.74,406.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,403.68l-8.55,3.24a.74.74,0,0,0-.47.79l1.1,7.54a1.21,1.21,0,0,0,1.65,1c3.06-1.22,5.67-2.77,9.57-4.17a64.73,64.73,0,0,0,12.78-5.75c2.9-1.84,1.68-5.34.31-4.79-6.22,2.5-7.75,3.32-14.28,2.06A3.87,3.87,0,0,0,150.79,403.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.7,152.49c2.63,4.66,5.41,9.46,8.21,14.1s5.67,9.28,8.72,13.6c.73,1.09,1.55,2.14,2.29,3.15a2.53,2.53,0,0,0,.65.76,2.47,2.47,0,0,0,1.52.24,10.74,10.74,0,0,0,2.79-.67,33.78,33.78,0,0,0,6.46-3.38c1.08-.71,2.18-1.44,3.25-2.22s2.15-1.62,3.13-2.37l4.69,4.18a44.24,44.24,0,0,1-2.75,3.57,44.8,44.8,0,0,1-3,3.31,39,39,0,0,1-3.43,3.07,28.58,28.58,0,0,1-4,2.74,19.91,19.91,0,0,1-5.08,2.07,13.51,13.51,0,0,1-6.75,0,12.71,12.71,0,0,1-6.17-3.89c-1-1.16-2-2.25-2.9-3.4a155.64,155.64,0,0,1-10.09-14.05c-3.1-4.82-6-9.65-8.66-14.79Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.84,152.88c-2.25,7.68,13.64,28.62,13.64,28.62l16-10.31a102.06,102.06,0,0,0-11.11-18.84C125.84,144,116.32,144.45,113.84,152.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.84,152.88c-2.25,7.68,13.64,28.62,13.64,28.62l16-10.31a102.06,102.06,0,0,0-11.11-18.84C125.84,144,116.32,144.45,113.84,152.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.61,161.89c3.3,1.41,8.15,9.35,10.68,15.24l-6.81,4.37a128.61,128.61,0,0,1-10.22-16C119.41,163.11,121.87,161.15,123.61,161.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.73,178.31l2.94-8.23,8.33,4s-1.73,7.33-7.83,7.32Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.08 164.67 178.61 168.56 176 174.06 167.67 170.08 175.08 164.67",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.39 385.65 148.86 395.4 141.03 398.37 138.56 388.62 146.39 385.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.78 388.3 94.16 388.3 93.51 398.29 85.13 398.29 85.78 388.3",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,149.48c9,31.81,7.54,65.56,8.1,72.42l44.76-1.68c7.61-47.42-6-73.81-6-73.81s-2.87-.55-6.78-.95c-1.22-.13-2.54-.24-3.92-.31-.76-.05-1.53-.07-2.31-.09a165.25,165.25,0,0,0-19,1.42c-1.19.15-2.4.32-3.58.52s-2.15.38-3.16.58C80,148.49,76.52,149.48,76.52,149.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,149.48c9,31.81,7.54,65.56,8.1,72.42l44.76-1.68c7.61-47.42-6-73.81-6-73.81s-2.87-.55-6.78-.95c-1.22-.13-2.54-.24-3.92-.31-.76-.05-1.53-.07-2.31-.09a165.25,165.25,0,0,0-19,1.42c-1.19.15-2.4.32-3.58.52s-2.15.38-3.16.58C80,148.49,76.52,149.48,76.52,149.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,163.13c.8,3.07-.12,17.12-3.33,20.58-.44-4.5-1-9.19-1.8-14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.62,125c1.65,6,3.68,17.12-.29,21.51,3.57,3.06,8.19,6.55,15.46,6.26s5.64-5.18,3.53-7.67c-6.94-1.12-7.14-6.18-6.3-11Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.98 151.7 108.3 152.59 103.48 154 104.72 151.76 106.98 151.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.8 151.23 108.3 152.59 113.14 154 112.81 151.41 108.8 151.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.44,146l1.9-.95a1.85,1.85,0,0,1,1.92.16A38.13,38.13,0,0,0,107,151.7c-3.82,1.82-2.88,6.72-2.88,6.72s-12.15-4-16-11.26A.86.86,0,0,1,88.44,146Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44,144.75l-2.79-.42a.37.37,0,0,0-.36.58c1,1.39,2.6,4.44-.49,6.32,3.82,1.82,5,6.29,5,6.29s5-5.37-.82-12.46A.93.93,0,0,0,112.44,144.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.67,128.66,104,134a19.21,19.21,0,0,0-.33,3.42c-2.63-.18-6.42-2.77-6.9-5.48A9.29,9.29,0,0,1,96.67,128.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87,112.61c-.34,2.91-3.13,5.41-4.93,6L105.69,106C110.74,102.43,113.34,108.53,112.87,112.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.09,116.1c1.46,8.18,1.89,13.05,6.54,16.8,7,5.64,16.73.69,17.75-7.76.92-7.61-1.62-19.71-10.06-22.06A11.34,11.34,0,0,0,89.09,116.1Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,121.62c3.79,2,5.45-2.51,5.49-4.35,0-2.92-1.22-6.13-2.73-7.3,7.32,0,21.8-.36,18.14-7.33s-11-6.18-16.47-2.36c-2.91,2-12.33.26-10,5.69C80.17,108.58,84.43,118.31,90.65,121.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.88,105.52a6,6,0,0,1-3.61-1.23,3.43,3.43,0,0,0,3.2,2.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,122.83a8,8,0,0,0,4.57,4c2.64.85,3.24-1.57,2.6-4.11-.58-2.3-1.82-5.41-4.51-5.16S84.88,120.53,86,122.83Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13,308.75c-3.4-25.33-9.75-88.53-9.75-88.53L100,221.33s13.88,63.15,18.9,88.76,19,87.41,19,87.41l13.26-5S142.68,335.09,139.13,308.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,238.35a15.58,15.58,0,0,0-6.55,3.35c2.78,12.77,6.41,29.58,9.53,44.39C116.06,273.26,116.12,249.05,111,238.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,220.82s-6.25,68.56-9.11,92.92c-3.13,26.69-7,82.62-7,82.62H82s-.63-49.47,1.36-75.59c2.27-29.75,1.25-98.87,1.25-98.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.4 396.69 81.34 396.69 80.96 391.29 101.12 390.94 99.4 396.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.89 392.16 137.09 398.15 135.16 393.04 152.72 386.08 152.89 392.16",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.86,117c.07.68.49,1.18.93,1.13s.73-.64.65-1.31-.49-1.17-.93-1.12S101.78,116.29,101.86,117Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.44,116.09c.08.67.5,1.17.93,1.12s.74-.63.66-1.3-.5-1.18-.94-1.13S109.36,115.42,109.44,116.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07,116.7a24.13,24.13,0,0,0,3.86,5.37,3.86,3.86,0,0,1-3.13,1Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,125.16a5.57,5.57,0,0,1-4.05-1.76.2.2,0,1,1,.31-.25,5.36,5.36,0,0,0,4.57,1.58.19.19,0,0,1,.22.17.2.2,0,0,1-.17.22A5.33,5.33,0,0,1,105.18,125.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.24,114.78a.35.35,0,0,1-.2,0,.39.39,0,0,1-.14-.54,3.94,3.94,0,0,1,3-2,.4.4,0,0,1,.42.38.39.39,0,0,1-.38.41h0a3.18,3.18,0,0,0-2.38,1.61A.36.36,0,0,1,99.24,114.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.41,113.11a.41.41,0,0,1-.33-.19,3.12,3.12,0,0,0-2.43-1.52.4.4,0,0,1,0-.8,4,4,0,0,1,3.09,1.9.39.39,0,0,1-.12.54A.38.38,0,0,1,112.41,113.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.58,408.18a10.18,10.18,0,0,1-2.21-.3.2.2,0,0,1-.15-.16.18.18,0,0,1,.08-.2c.29-.19,2.91-1.85,3.86-1.38a.68.68,0,0,1,.37.56,1.13,1.13,0,0,1-.36,1.05A2.42,2.42,0,0,1,96.58,408.18Zm-1.64-.58c1.43.28,2.52.23,3-.15a.8.8,0,0,0,.24-.72c0-.16-.09-.21-.14-.23C97.51,406.25,96,407,94.94,407.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.42,407.88a.23.23,0,0,1-.11,0,.22.22,0,0,1-.1-.18c0-.1.09-2.52,1-3.31a1,1,0,0,1,.83-.26h0a.69.69,0,0,1,.66.52c.22.93-1.36,2.77-2.21,3.24A.13.13,0,0,1,94.42,407.88Zm1.52-3.39a.67.67,0,0,0-.44.17,4.54,4.54,0,0,0-.86,2.63c.83-.66,1.82-2,1.69-2.6,0-.05,0-.16-.3-.2h-.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,404.47a.19.19,0,0,1-.18-.11.2.2,0,0,1,0-.22c.29-.32,2.83-3.11,4-2.94a.62.62,0,0,1,.5.37h0a1.1,1.1,0,0,1,0,1c-.57,1.08-2.93,1.63-4.29,1.85Zm3.69-2.88c-.67,0-2.13,1.31-3.15,2.38,1.84-.37,3.1-.94,3.42-1.55a.74.74,0,0,0,0-.68.24.24,0,0,0-.19-.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,404.47h-.06a.2.2,0,0,1-.14-.14c0-.09-.61-2.28.07-3.48a1.45,1.45,0,0,1,.91-.7h0c.53-.15.77.06.89.25.48.83-.75,3.24-1.54,4A.16.16,0,0,1,152,404.47Zm1.09-4-.21,0h0a1,1,0,0,0-.66.52,4.62,4.62,0,0,0-.12,2.81c.74-1,1.51-2.76,1.22-3.26C153.28,400.56,153.23,400.48,153.06,400.49Zm-.26-.16h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.72,161.32c-2.51,5.17-5.07,10.51-7.55,15.77-1.23,2.65-2.47,5.29-3.63,7.94l-1.74,4L72,191l-.2.5-.15.37c-.1.23-.17.48-.26.71a12.2,12.2,0,0,0-.32,6.09,21,21,0,0,0,2.63,6.65,41.73,41.73,0,0,0,4.76,6.44c.91,1,1.87,2.06,2.87,3,.5.48,1,1,1.53,1.43s1.06,1,1.5,1.35L81,222.89a40.15,40.15,0,0,1-4.19-2.46c-1.33-.87-2.63-1.79-3.89-2.79a43,43,0,0,1-7-7,29.33,29.33,0,0,1-5.05-9.36,22.54,22.54,0,0,1-.49-11.58c.13-.47.23-1,.38-1.42l.39-1.24.7-2.21c.5-1.45,1-2.91,1.52-4.34,1.05-2.87,2.15-5.71,3.34-8.51C69,166.4,71.57,161,74.43,155.53Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,149.48c-7.64,2.39-15.15,28.3-15.15,28.3L79,185.52s5.72-12.52,9-22.33C91.63,152.5,85.77,146.58,76.52,149.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,149.48c-7.64,2.39-15.15,28.3-15.15,28.3L79,185.52s5.72-12.52,9-22.33C91.63,152.5,85.77,146.58,76.52,149.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46,215.92l7.31,4.34-7.11,7.08s-6.17-4.75-4.33-8.47Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.66 227.19 87.32 232.33 82.66 227.34 89.77 220.26 94.66 227.19",
    style: {
      fill: "#b55b52"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.3,
    y: 215.99,
    width: 4.83,
    height: 1,
    transform: "translate(200.37 648.4) rotate(-85.86)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 202.34,
    width: 14.01,
    height: 1,
    transform: "translate(214.9 636.7) rotate(-85.86)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.32,353H177.39a12.54,12.54,0,0,1-12.64-13.61l13-180.8A14.9,14.9,0,0,1,192.3,145H437.23a12.53,12.53,0,0,1,12.64,13.6l-13,180.8A14.9,14.9,0,0,1,422.32,353Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.35 416.24 285.84 416.24 271.67 318 351.18 318 365.35 416.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.72 410.38 266.72 410.38 265.01 416.24 351.02 416.24 352.72 410.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.37 365.29 277.88 361.06 271.67 318 348.55 318 355.37 365.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.56,353H174.62A12.53,12.53,0,0,1,162,339.35l13-180.8A14.9,14.9,0,0,1,189.53,145H434.47a12.53,12.53,0,0,1,12.63,13.6l-13,180.8A14.89,14.89,0,0,1,419.56,353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.26,
    y: 211.73,
    width: 103.98,
    height: 0.96,
    transform: "translate(199.87 639.13) rotate(-85.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.6,
    y: 290.55,
    width: 36.01,
    height: 0.96,
    transform: "translate(116.04 706.71) rotate(-85.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,349.58H175.62a9.76,9.76,0,0,1-9.83-10.6L178.7,158.92a11.6,11.6,0,0,1,11.35-10.59H433.47a9.76,9.76,0,0,1,9.83,10.59L430.39,339A11.6,11.6,0,0,1,419,349.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,349.58H175.62a9.76,9.76,0,0,1-9.83-10.6L178.7,158.92a11.6,11.6,0,0,1,11.35-10.59H433.47a9.76,9.76,0,0,1,9.83,10.59L430.39,339A11.6,11.6,0,0,1,419,349.58Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,341.6H181.22a4.71,4.71,0,0,1-4.75-5.12l12.54-175a5.6,5.6,0,0,1,5.49-5.12h56.84a4.7,4.7,0,0,1,4.75,5.12L243.55,336.48A5.61,5.61,0,0,1,238.06,341.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,181H206.44a4.25,4.25,0,0,1-4.28-4.61l.32-4.51a5.05,5.05,0,0,1,4.94-4.61h29.43a4.25,4.25,0,0,1,4.28,4.61l-.33,4.51A5,5,0,0,1,235.86,181Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15,251.8H172.24a7.4,7.4,0,0,1-7.47-8L168,198.84a8.81,8.81,0,0,1,8.62-8h44.92a7.4,7.4,0,0,1,7.46,8l-3.22,44.92A8.8,8.8,0,0,1,217.15,251.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,215a3.36,3.36,0,0,0-3.28,3.07l-.47,6.52a2.82,2.82,0,0,0,2.85,3.06h4.56a.82.82,0,0,0,.81-.76l.8-11.13a.7.7,0,0,0-.71-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,202.23H178a1.13,1.13,0,0,1-1.14-1.23h0a1.34,1.34,0,0,1,1.32-1.23h28.31a1.13,1.13,0,0,1,1.14,1.23h0A1.35,1.35,0,0,1,206.26,202.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.82,208.48H177.5a1.13,1.13,0,0,1-1.14-1.23h0a1.34,1.34,0,0,1,1.32-1.22H206a1.12,1.12,0,0,1,1.14,1.22h0A1.34,1.34,0,0,1,205.82,208.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.58,214.74H177.05a1.14,1.14,0,0,1-1.14-1.23h0a1.34,1.34,0,0,1,1.32-1.23h18.53a1.13,1.13,0,0,1,1.14,1.23h0A1.35,1.35,0,0,1,195.58,214.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.34,244.54H179a4.84,4.84,0,0,1-4.88-5.26l1-14.39a5.74,5.74,0,0,1,5.63-5.25h27.39a4.84,4.84,0,0,1,4.88,5.25l-1,14.39A5.76,5.76,0,0,1,206.34,244.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.91,268.62H197.83a2.1,2.1,0,0,1-2.12-2.28h0a2.5,2.5,0,0,1,2.45-2.28h34.08a2.1,2.1,0,0,1,2.11,2.28h0A2.49,2.49,0,0,1,231.91,268.62Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,277.57H203.42a2.1,2.1,0,0,1-2.12-2.28h0a2.49,2.49,0,0,1,2.44-2.28h21.63a2.09,2.09,0,0,1,2.11,2.28h0A2.49,2.49,0,0,1,225,277.57Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,293.31H196.06a2.11,2.11,0,0,1-2.12-2.28h0a2.5,2.5,0,0,1,2.45-2.28h34.08a2.1,2.1,0,0,1,2.11,2.28h0A2.49,2.49,0,0,1,230.14,293.31Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,302.25H201.65a2.09,2.09,0,0,1-2.12-2.27h0A2.49,2.49,0,0,1,202,297.7H223.6a2.1,2.1,0,0,1,2.12,2.28h0A2.49,2.49,0,0,1,223.27,302.25Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,318H194.29a2.11,2.11,0,0,1-2.12-2.28h0a2.49,2.49,0,0,1,2.45-2.28H228.7a2.09,2.09,0,0,1,2.11,2.28h0A2.49,2.49,0,0,1,228.37,318Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5,326.94H199.88a2.1,2.1,0,0,1-2.12-2.28h0a2.5,2.5,0,0,1,2.44-2.28h21.63a2.11,2.11,0,0,1,2.12,2.28h0A2.49,2.49,0,0,1,221.5,326.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.68,290.27c1.48-2.26,4.87-1.31,4.68,1.3l-3.28,45.76c-.17,2.35-1.95,4.27-4,4.27H254.27c-2,0-3.52-1.92-3.35-4.27l2-27.19a5.89,5.89,0,0,1,7.42-5.23c9.29,2.89,17.25,1.19,24.65-2.48,15.82-7.85,29.06-24.71,47.25-24.71.7,0,1.39,0,2.06.06,27.06,1.63,35.3,35.25,56.26,35.25,6.2,0,11.85-2.68,16.78-6.49C413.32,301.87,418.25,295.5,421.68,290.27Z",
    style: {
      fill: "#407BFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.1,309.12l-2,28.21c-.17,2.35-1.95,4.27-4,4.27H254.27c-2,0-3.52-1.92-3.35-4.27l4-56.06c.27-3.84,5.3-5.46,7.34-2.35,5.26,8,13.35,18.39,22.66,23.51a23.15,23.15,0,0,0,11.13,3.15c13.32,0,24.65-15.79,38.18-27.8,8.29-7.36,17.41-13.3,28.32-13.3,22.77,0,26.13,37,44.72,42.06,3.58,1,7.73.77,12.69-1.13A3.69,3.69,0,0,1,425.1,309.12Z",
    style: {
      fill: "#407BFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.91,298.18a.37.37,0,0,1-.24-.1.26.26,0,0,1-.07-.11.31.31,0,0,1,0-.13.33.33,0,0,1,.1-.24.34.34,0,0,1,.48,0,.31.31,0,0,1,.1.24.59.59,0,0,1,0,.13.44.44,0,0,1-.08.11A.35.35,0,0,1,425.91,298.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.64,321.61a.34.34,0,0,1-.34-.34h0a.34.34,0,0,1,.34-.33h0a.34.34,0,0,1,.34.34h0a.35.35,0,0,1-.34.35h0Zm-3.43-.19h0a.33.33,0,0,1-.31-.37h0a.34.34,0,0,1,.38-.3h0a.34.34,0,0,1,.3.37h0a.35.35,0,0,1-.34.31h0Zm6.47-.3a.34.34,0,0,1,.3-.38h0a.34.34,0,0,1,.38.3h0a.34.34,0,0,1-.3.38h0A.34.34,0,0,1,268.68,321.12Zm-9.85-.22a.36.36,0,0,1-.27-.41h0a.36.36,0,0,1,.41-.27h0a.36.36,0,0,1,.27.41h0a.35.35,0,0,1-.34.27h-.07Zm13.19-.34a.34.34,0,0,1,.25-.42h0a.35.35,0,0,1,.41.25h0a.35.35,0,0,1-.25.42h-.08A.33.33,0,0,1,272,320.56Zm109.37.14a.34.34,0,0,1-.34-.34h0a.34.34,0,0,1,.34-.34h0a.34.34,0,0,1,.34.34h0a.34.34,0,0,1-.34.34Zm3.05-.48a.33.33,0,0,1,.3-.37h0a.33.33,0,0,1,.38.3h0a.35.35,0,0,1-.31.38h0A.35.35,0,0,1,384.44,320.22Zm-6.47.27a.33.33,0,0,1-.29-.38h0a.34.34,0,0,1,.38-.3h0a.35.35,0,0,1,.3.38h0a.35.35,0,0,1-.34.31h0Zm-122.46-.41a.34.34,0,0,1-.24-.42h0a.36.36,0,0,1,.43-.24h0a.35.35,0,0,1,.23.43h0a.33.33,0,0,1-.33.24h-.09Zm132.29-.33a.33.33,0,0,1,.27-.4h0a.34.34,0,0,1,.4.27h0a.34.34,0,0,1-.27.4h-.06A.35.35,0,0,1,387.8,319.75Zm-13.19.12a.32.32,0,0,1-.25-.41h0a.34.34,0,0,1,.41-.25h0a.34.34,0,0,1,.25.41h0a.34.34,0,0,1-.33.26h-.08Zm-99.35-.28a.33.33,0,0,1,.2-.44h0a.34.34,0,0,1,.44.19h0a.34.34,0,0,1-.2.44h0a.27.27,0,0,1-.12,0h0A.35.35,0,0,1,275.26,319.59ZM391.11,319a.34.34,0,0,1,.24-.43h0a.34.34,0,0,1,.42.24h0a.34.34,0,0,1-.24.42h0l-.09,0h0A.34.34,0,0,1,391.11,319Zm-19.78-.12h0a.34.34,0,0,1-.21-.43h0a.35.35,0,0,1,.44-.21h0a.35.35,0,0,1,.21.44h0a.35.35,0,0,1-.33.22h0A.2.2,0,0,1,371.33,318.88Zm-93-.64a.34.34,0,0,1,.15-.46h0a.35.35,0,0,1,.46.16h0a.33.33,0,0,1-.15.45h0a.29.29,0,0,1-.16,0h0A.34.34,0,0,1,278.37,318.24Zm116-.24a.33.33,0,0,1,.2-.43h0a.35.35,0,0,1,.43.21h0a.35.35,0,0,1-.21.44h0l-.11,0h0A.34.34,0,0,1,394.36,318Zm-26.19-.42h0a.34.34,0,0,1-.17-.45h0a.35.35,0,0,1,.45-.17h0a.34.34,0,0,1,.17.46h0a.35.35,0,0,1-.31.2h0A.23.23,0,0,1,368.17,317.58Zm29.36-.78a.33.33,0,0,1,.19-.44h0a.32.32,0,0,1,.44.18h0a.34.34,0,0,1-.18.45h0a.3.3,0,0,1-.13,0h0A.35.35,0,0,1,397.53,316.8Zm-116.2-.2a.35.35,0,0,1,.11-.48h0a.34.34,0,0,1,.47.11h0a.34.34,0,0,1-.11.47h0a.3.3,0,0,1-.18.06h0A.36.36,0,0,1,281.33,316.6Zm83.79-.55h0a.35.35,0,0,1-.14-.47h0a.35.35,0,0,1,.47-.13h0a.34.34,0,0,1,.13.46h0a.35.35,0,0,1-.3.18h0A.47.47,0,0,1,365.12,316.05Zm35.52-.62a.34.34,0,0,1,.16-.45h0a.35.35,0,0,1,.46.16h0a.34.34,0,0,1-.17.45h0l-.15,0h0A.34.34,0,0,1,400.64,315.43Zm-116.49-.71a.35.35,0,0,1,.08-.48h0a.35.35,0,0,1,.48.07h0a.35.35,0,0,1-.08.48h0a.37.37,0,0,1-.2.07h0A.35.35,0,0,1,284.15,314.72Zm78-.38h0a.33.33,0,0,1-.11-.46h0a.32.32,0,0,1,.46-.12h0a.34.34,0,0,1,.12.47h0a.35.35,0,0,1-.29.17h0A.37.37,0,0,1,362.17,314.34Zm41.51-.43a.34.34,0,0,1,.14-.46h0a.35.35,0,0,1,.46.14h0a.35.35,0,0,1-.14.47h0a.47.47,0,0,1-.16,0h0A.34.34,0,0,1,403.68,313.91Zm-116.81-1.24a.34.34,0,0,1,.05-.48h0a.35.35,0,0,1,.48.05h0a.36.36,0,0,1,0,.49h0a.36.36,0,0,1-.22.07h0A.3.3,0,0,1,286.87,312.67Zm72.42-.15h0a.34.34,0,0,1-.1-.47h0a.35.35,0,0,1,.48-.1h0a.35.35,0,0,1,.1.47h0a.34.34,0,0,1-.29.16h0A.41.41,0,0,1,359.29,312.52Zm47.36-.25a.34.34,0,0,1,.12-.47h0a.35.35,0,0,1,.47.12h0a.35.35,0,0,1-.12.47h0a.41.41,0,0,1-.18.05h0A.34.34,0,0,1,406.65,312.27Zm-50.19-1.64a.35.35,0,0,1-.09-.48h0a.36.36,0,0,1,.48-.09h0a.36.36,0,0,1,.09.48h0a.35.35,0,0,1-.29.15h0A.35.35,0,0,1,356.46,310.63Zm53.09-.12a.36.36,0,0,1,.11-.48h0a.34.34,0,0,1,.47.11h0a.34.34,0,0,1-.11.47h0a.28.28,0,0,1-.18.06h0A.36.36,0,0,1,409.55,310.51Zm-120,0a.35.35,0,0,1,0-.48h0a.36.36,0,0,1,.49,0h0a.34.34,0,0,1,0,.48h0a.3.3,0,0,1-.22.08h0A.35.35,0,0,1,289.5,310.53Zm122.9-1.88a.35.35,0,0,1,.08-.48h0a.34.34,0,0,1,.48.09h0a.34.34,0,0,1-.09.47h0a.35.35,0,0,1-.19.06h0A.34.34,0,0,1,412.4,308.65Zm-58.75.08a.33.33,0,0,1-.09-.47h0a.34.34,0,0,1,.47-.1h0a.34.34,0,0,1,.09.48h0a.32.32,0,0,1-.28.15h0A.35.35,0,0,1,353.65,308.73Zm-61.54-.38a.33.33,0,0,1,0-.48h0a.35.35,0,0,1,.48,0h0a.34.34,0,0,1,0,.48h0a.32.32,0,0,1-.22.08h0A.32.32,0,0,1,292.11,308.35Zm58.72-1.5a.33.33,0,0,1-.1-.47h0a.33.33,0,0,1,.47-.1h0a.34.34,0,0,1,.1.47h0a.32.32,0,0,1-.28.15h0A.32.32,0,0,1,350.83,306.85Zm64.35-.16a.33.33,0,0,1,.07-.47h0a.35.35,0,0,1,.48.07h0a.35.35,0,0,1-.08.48h0a.36.36,0,0,1-.2.06h0A.31.31,0,0,1,415.18,306.69Zm-120.46-.51a.34.34,0,0,1,0-.48h0a.35.35,0,0,1,.48.05h0a.34.34,0,0,1-.05.48h0a.3.3,0,0,1-.22.08h0A.33.33,0,0,1,294.72,306.18ZM348,305a.34.34,0,0,1-.11-.47h0a.34.34,0,0,1,.47-.11h0a.34.34,0,0,1,.11.47h0a.35.35,0,0,1-.29.17h0A.3.3,0,0,1,348,305Zm69.92-.36a.34.34,0,0,1,.06-.48h0a.34.34,0,0,1,.48.06h0a.36.36,0,0,1-.06.48h0a.31.31,0,0,1-.2.07h0A.34.34,0,0,1,417.9,304.66Zm-120.52-.58a.35.35,0,0,1,.07-.48h0a.35.35,0,0,1,.48.07h0a.35.35,0,0,1-.07.48h0a.37.37,0,0,1-.2.07h0A.35.35,0,0,1,297.38,304.08Zm47.69-.79a.34.34,0,0,1-.12-.47h0a.33.33,0,0,1,.46-.12h0a.33.33,0,0,1,.13.46h0a.35.35,0,0,1-.3.18h0A.41.41,0,0,1,345.07,303.29Zm75.48-.75a.34.34,0,0,1,.05-.48h0a.34.34,0,0,1,.48.05h0a.35.35,0,0,1,0,.48h0a.4.4,0,0,1-.22.08h0A.34.34,0,0,1,420.55,302.54Zm-120.41-.44a.34.34,0,0,1,.09-.48h0a.35.35,0,0,1,.48.1h0a.34.34,0,0,1-.1.47h0a.33.33,0,0,1-.19.06h0A.35.35,0,0,1,300.14,302.1Zm42-.42a.34.34,0,0,1-.14-.46h0a.34.34,0,0,1,.46-.15h0a.37.37,0,0,1,.15.47h0a.37.37,0,0,1-.31.18h0A.32.32,0,0,1,342.1,301.68Zm81-1.33a.34.34,0,0,1,0-.48h0a.35.35,0,0,1,.48,0h0a.35.35,0,0,1,0,.48h0a.31.31,0,0,1-.22.09h0A.34.34,0,0,1,423.15,300.35ZM303,300.29a.34.34,0,0,1,.13-.47h0a.34.34,0,0,1,.46.13h0a.34.34,0,0,1-.13.47h0a.38.38,0,0,1-.17,0h0A.34.34,0,0,1,303,300.29Zm36.05-.06h0a.34.34,0,0,1-.17-.45h0a.34.34,0,0,1,.45-.17h0a.33.33,0,0,1,.17.45h0a.34.34,0,0,1-.31.2h0A.35.35,0,0,1,339.06,300.23ZM335.94,299a.33.33,0,0,1-.2-.44h0a.35.35,0,0,1,.44-.2h0a.35.35,0,0,1,.2.44h0a.33.33,0,0,1-.32.22h0A.25.25,0,0,1,335.94,299ZM306,298.72a.35.35,0,0,1,.17-.45h0a.34.34,0,0,1,.46.17h0a.34.34,0,0,1-.18.45h0a.32.32,0,0,1-.14,0h0A.34.34,0,0,1,306,298.72Zm26.73-.81a.35.35,0,0,1-.23-.43h0a.35.35,0,0,1,.43-.23h0a.35.35,0,0,1,.23.43h0a.35.35,0,0,1-.33.24h-.1Zm-23.59-.47a.34.34,0,0,1,.22-.43h0a.34.34,0,0,1,.43.22h0a.34.34,0,0,1-.22.43h0l-.11,0h0A.34.34,0,0,1,309.15,297.44Zm20.33-.36a.34.34,0,0,1-.26-.4h0a.33.33,0,0,1,.41-.26h0a.33.33,0,0,1,.26.4h0a.34.34,0,0,1-.34.27h-.07Zm-17.08-.57a.34.34,0,0,1,.27-.41h0a.34.34,0,0,1,.4.26h0a.34.34,0,0,1-.26.41h-.07A.35.35,0,0,1,312.4,296.51Zm13.77,0h0a.35.35,0,0,1-.29-.39h0a.33.33,0,0,1,.38-.29h0a.35.35,0,0,1,.29.39h0a.35.35,0,0,1-.34.29h-.05Zm-10.43-.57a.34.34,0,0,1,.3-.37h0a.33.33,0,0,1,.38.3h0a.35.35,0,0,1-.31.38h0A.35.35,0,0,1,315.74,295.93Zm7.08.22h0a.33.33,0,0,1-.32-.36h0a.34.34,0,0,1,.36-.32h0a.35.35,0,0,1,.32.37h0a.34.34,0,0,1-.34.32h0Zm-3.7-.44a.33.33,0,0,1,.34-.34h0a.34.34,0,0,1,.34.34h0a.34.34,0,0,1-.34.34h0A.34.34,0,0,1,319.12,295.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25,319a.31.31,0,0,1-.13,0,.28.28,0,0,1-.11-.08.21.21,0,0,1-.07-.11.28.28,0,0,1,0-.13.37.37,0,0,1,.1-.24.26.26,0,0,1,.11-.07.3.3,0,0,1,.26,0,.21.21,0,0,1,.11.07.33.33,0,0,1,.1.24.27.27,0,0,1,0,.13.23.23,0,0,1-.08.11.28.28,0,0,1-.11.08A.28.28,0,0,1,252.25,319Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.08,216.61h0l-2.33-2.52a22.89,22.89,0,0,1-15.56,6.26,19.57,19.57,0,0,1-19.52-15.84l-3.5.92h0l-3.2.84a25.76,25.76,0,0,0,6.39,12.63c10.15,10.94,28.14,10.94,39.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.07,179.05,309,181.9h0l-2.11,2A19.9,19.9,0,0,1,312.09,199a23,23,0,0,1-7.34,15.11l1.83,2h0l2.64,2.84A30.39,30.39,0,0,0,318.9,199,26.32,26.32,0,0,0,312.07,179.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.07,179.05c-10.15-10.93-28.14-10.93-39.85,0A29.81,29.81,0,0,0,263,206.27l4-1h0l2.74-.72a21.05,21.05,0,0,1-.32-5.53,23.33,23.33,0,0,1,22.9-21.37,19.79,19.79,0,0,1,14.66,6.26l2.7-2.53h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,216.61h0l2.69-2.52A19.88,19.88,0,0,1,338.32,199a23.43,23.43,0,0,1,17.32-20.65l-.68-3.44h0l-.61-3.14a30.9,30.9,0,0,0-13.16,7.3c-11.72,10.93-13,28.92-2.86,39.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.19,218.91l-2.65-2.86h0l-1.82-2a22.88,22.88,0,0,1-15.56,6.27,19.81,19.81,0,0,1-14.67-6.26l-2.11,2h0l-3.05,2.85a26.24,26.24,0,0,0,19.34,8.25A30.29,30.29,0,0,0,378.19,218.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.19,218.91c11.71-10.94,13-28.93,2.86-39.86a26.87,26.87,0,0,0-26.7-7.3l.76,3.89h0l.53,2.69a22,22,0,0,1,5.58-.72A19.63,19.63,0,0,1,381.06,199a23,23,0,0,1-7.34,15.1l2.34,2.53h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.42,173.31a2,2,0,0,1,2,2.14l-1.24,17.25a2.51,2.51,0,0,1-2.43,2.27H406.49a2,2,0,0,1-2-2.15l1.23-17.25a2.5,2.5,0,0,1,2.43-2.26h17.25m0-.89H408.17a3.39,3.39,0,0,0-3.31,3.09l-1.23,17.25a2.85,2.85,0,0,0,2.86,3.09h17.25a3.38,3.38,0,0,0,3.31-3.09l1.24-17.25a2.85,2.85,0,0,0-2.87-3.09Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.29,203a2,2,0,0,1,2,2.14l-1.23,17.25a2.52,2.52,0,0,1-2.43,2.27H404.37a2,2,0,0,1-2-2.15l1.24-17.25a2.5,2.5,0,0,1,2.43-2.26h17.24m0-.89H406.05a3.38,3.38,0,0,0-3.31,3.09l-1.24,17.25a2.85,2.85,0,0,0,2.87,3.09h17.25a3.39,3.39,0,0,0,3.31-3.09l1.23-17.25a2.85,2.85,0,0,0-2.87-3.09Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,298.43a1.64,1.64,0,0,1,1.24.52,1.67,1.67,0,0,1,.43,1.28,2.11,2.11,0,0,1-2.06,1.93,1.63,1.63,0,0,1-1.67-1.8,2.1,2.1,0,0,1,2.06-1.93m0-.88a3,3,0,0,0-2.94,2.74,2.52,2.52,0,0,0,2.55,2.75,3,3,0,0,0,2.94-2.75,2.52,2.52,0,0,0-2.55-2.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.26 297.56 397.82 297.53 397.89 296.65 398.32 296.68 398.26 297.56",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.45,294.88l-.44,0,.13-1.8.44,0Zm.26-3.62-.44,0,.13-1.8.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Zm.26-3.62-.44,0,.13-1.8.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Zm.25-3.61-.44,0,.13-1.81.44,0Zm.26-3.61-.44,0,.13-1.81.44,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.67,
    y: 254.47,
    width: 0.88,
    height: 0.44,
    transform: "translate(118.65 636.76) rotate(-85.94)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.78,254.73H261.44a3.1,3.1,0,0,1-2.31-1,3.14,3.14,0,0,1-.83-2.39l.79-10.9a3.6,3.6,0,0,1,3.54-3.3H421a3.12,3.12,0,0,1,3.13,3.37l-.78,10.9A3.61,3.61,0,0,1,419.78,254.73ZM262.63,238.1a2.64,2.64,0,0,0-2.59,2.42l-.78,10.9a2.2,2.2,0,0,0,.57,1.67,2.17,2.17,0,0,0,1.61.68H419.78a2.63,2.63,0,0,0,2.59-2.42l.79-10.9A2.18,2.18,0,0,0,421,238.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.38,244.18H266.28a1.37,1.37,0,0,1-1.38-1.49h0a1.63,1.63,0,0,1,1.59-1.48H416.6a1.36,1.36,0,0,1,1.37,1.48h0A1.62,1.62,0,0,1,416.38,244.18Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.37,250.43H265.83a1.36,1.36,0,0,1-1.37-1.48h0a1.62,1.62,0,0,1,1.59-1.49H391.58A1.37,1.37,0,0,1,393,249h0A1.63,1.63,0,0,1,391.37,250.43Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.8
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.60ae963e20e14f621fc1ef4453954344.svg";
export { ForwardRef as ReactComponent };